import { bindEvents } from './helpers';

import AnimationController from './controller/animation';
import CursorController from './controller/cursor';
import PageController from './controller/page';
import ResizeController from './controller/resize';
import RoutingController from './controller/routing';
import ScrollController from './controller/scroll';
import SectionController from './controller/section';
import SpotifyController from './controller/spotify';
import UiController from './controller/ui';
// import WebglController from './controller/webgl';

const isIframe = window.location.pathname.includes('styleguide/iframe');

class App {

	constructor() {
		this.el = {};

		this.events = bindEvents(this);

		this.initialize();
	}

	initialize() {
		this.addEventListeners();
	}

	collectGlobalElements() {
		this.el = {
			webgl: document.querySelector('.webgl'),
			header: document.querySelector('main > header'),
			footer: document.querySelector('main > footer'),
			smoothScroll: document.querySelector('.smooth-scroll'),
			smoothScrollContent: document.querySelector('.smooth-scroll__content')
		};
	}

	configureControllers() {
		PageController.wrapper = this.el.smoothScrollContent;
		ScrollController.wrapper = this.el.smoothScroll;
		ScrollController.start();

		CursorController.initialize(this.el.smoothScrollContent);
		ResizeController.initialize(this.el.smoothScrollContent);
		UiController.initialize(this.el.smoothScrollContent);

		// WebglController.wrapper = this.el.webgl;
		// WebglController.start();

		AnimationController.start();

		RoutingController.overrideAnchor();
		RoutingController.start({
			'/': () => this.open('pages', 'home', true, true),
			'/:slug': (slug) => this.open('pages', slug, true, true),
			'/interviews/:slug': (slug) => this.open('interviews', slug, true, true),
			'/experiences/:slug': (slug) => this.open('experiences', slug, true, true)
		});

		SpotifyController.start();
	}

	load(type, slug) {
		return new Promise((resolve, reject) => {
			PageController.load(type, slug).then(() => {
				resolve();
			}).catch(() => {
				reject();
			});
		});
	}

	open(type, slug, animate = true, override = true) {
		// animate (true/false): show intro and outro for each page
		// override (true/false): cancel any currently preloading pages
		return new Promise((resolve, reject) => {
			if (override) {
				PageController.cancel();
			}

			if (PageController.active && !PageController.isActivePage(type, slug)) {
				UiController.pageOut(animate);
			}

			PageController.open(type, slug).then(() => {
				this.renderPage(animate);
				resolve();
			}).catch(() => {
				this.renderPageError(false);
				reject();
			});
		});
	}

	renderPage(animate = true) {
		const $activePage = PageController.activePageEl;

		if ($activePage) {
			const { active, previous } = PageController;

			// conditional class for scroll to next pages
			$activePage.classList.add(animate ? 'page--is-not-scroll-to-next' : 'page--is-scroll-to-next');

			if (previous !== null) {
				// remove previous pages
				SectionController.destroy(previous.id);
				PageController.close(previous.id);
			} else {
				// initialize first load
				SectionController.initializeGlobals();
			}

			// reset scroll position
			ScrollController.scrollTo(0, true);

			// initialize page bits, modules
			SectionController.initialize(active.id, $activePage);

			// resize scroll area
			ResizeController.measure(true);

			// override page links to use router
			RoutingController.overrideAnchor($activePage);

			// new page animate in (transition = true)
			UiController.pageIn(true).then(() => {
				PageController.showActivePage();
			});

			// webgl
			// WebglController.gatherElements(page);
		} else {
			console.error('Page Rendering Error'); // eslint-disable-line no-console
		}
	}

	renderPageError(animate = false) {
		// cancel page out / immediately show page in (transition = false)
		UiController.pageIn(animate);
	}

	_onDOMContentLoaded() {
		if (!isIframe) {
			this.collectGlobalElements();
			this.configureControllers();
		}
	}

	addEventListeners() {
		document.addEventListener('DOMContentLoaded', this.events._onDOMContentLoaded);
	}

}

export default new App();
